/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiJingleCollectionsIdMutationRequest, PutApiJingleCollectionsIdMutationResponse, PutApiJingleCollectionsIdPathParams, PutApiJingleCollectionsId400, PutApiJingleCollectionsId401, PutApiJingleCollectionsId403, PutApiJingleCollectionsId404, PutApiJingleCollectionsId500 } from "../../types/PutApiJingleCollectionsId.ts";
import { putApiJingleCollectionsIdMutationResponseSchema, putApiJingleCollectionsIdMutationRequestSchema } from "../../zod/JingleCollectionSchemas/putApiJingleCollectionsIdSchema.ts";

function getPutApiJingleCollectionsIdUrl({ id }: { id: PutApiJingleCollectionsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/jingle-collections/${id}` as const }  
  return res
}

/**
 * @summary Обновление подборки джинглов
 * {@link /api/jingle-collections/:Id}
 */
export async function putApiJingleCollectionsId({ id, data }: { id: PutApiJingleCollectionsIdPathParams["Id"]; data?: PutApiJingleCollectionsIdMutationRequest }, config: Partial<RequestConfig<PutApiJingleCollectionsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiJingleCollectionsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiJingleCollectionsIdMutationResponse, ResponseErrorConfig<PutApiJingleCollectionsId400 | PutApiJingleCollectionsId401 | PutApiJingleCollectionsId403 | PutApiJingleCollectionsId404 | PutApiJingleCollectionsId500>, PutApiJingleCollectionsIdMutationRequest>({ method : "PUT", url : getPutApiJingleCollectionsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiJingleCollectionsIdMutationResponseSchema.parse(res.data)
}